(function ($) {
    $(function () {

    const h = $(window).height();

        $('.entry-header__top').height(h * 0.3);
        $('.entry-header__middle').height(h * 0.56);
        $('.entry-header__bottom').height(h * 0.14);

    });
})(jQuery);